import useInView from '../hooks/useInView';
import { useTranslation } from 'react-i18next';

const ComicHeroes = () => {
  const [ref, inView] = useInView({ threshold: 0.15 });
  const { t, i18n } = useTranslation('common');
  const defaultHeroes = [
    { id: 1, name: 'Marcus Steel', image: '/assets/imgs/Home/Our Comic Heroes/1.png' },
    { id: 2, name: 'Luna Nightshade', image: '/assets/imgs/Home/Our Comic Heroes/2.png' },
    { id: 3, name: 'Zara Phoenix', image: '/assets/imgs/Home/Our Comic Heroes/3.png' },
    { id: 4, name: 'Kai Stormwind', image: '/assets/imgs/Home/Our Comic Heroes/4.png' },
    { id: 5, name: 'Nova Starlight', image: '/assets/imgs/Home/Our Comic Heroes/5.png' },
    { id: 6, name: 'Raven Shadow', image: '/assets/imgs/Home/Our Comic Heroes/6.png' }
  ];

  const translated = t('home.heroes.items', { returnObjects: true }) || [];
  const lng = (i18n.language || 'en').split('-')[0];
  const fallbacks = {
    ar: ['ماركوس ستيل','لونا نايتشيد','زارا فينكس','كاي ستورمويند','نوفا ستارلايت','رافين شادو'],
    ur: ['مارکس اسٹیل','لونا نائٹ شیڈ','زارا فینکس','کائی اسٹورم ونڈ','نووا اسٹار لائٹ','ریون شیڈو'],
    fr: ['Marcus Steel','Luna Nightshade','Zara Phoenix','Kai Stormwind','Nova Starlight','Raven Shadow'],
    it: ['Marcus Steel','Luna Nightshade','Zara Phoenix','Kai Stormwind','Nova Starlight','Raven Shadow'],
    ru: ['Маркус Стил','Луна Найтшейд','Зара Феникс','Кай Штормвинд','Нова Старлайт','Рэйвен Шэдоу']
  };
  const fallbackNames = fallbacks[lng];
  const heroes = defaultHeroes.map((h, idx) => {
    const nameFromI18n = translated[idx]?.name;
    const nameFromFallback = fallbackNames ? fallbackNames[idx] : undefined;
    return { ...h, name: nameFromI18n || nameFromFallback || h.name };
  });

  return (
    <section ref={ref} className="bg-cream py-16 lg:py-24" id="heroes">
      <div className="container mx-auto px-8 lg:px-16">
        {/* Section Title */}
        <div className={`text-center mb-12 transition-all duration-800 ease-out ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
          <h2 className="text-4xl lg:text-5xl font-bold text-text-dark mb-0">{t('home.heroes.title', { defaultValue: 'Our Comic Heroes' })}</h2>
        </div>

        {/* Heroes Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 lg:gap-6 mb-8">
          {heroes.map((hero, idx) => (
            <div
              key={hero.id}
              className={`flex flex-col items-center group transition-all duration-800 ease-out ${inView ? 'opacity-100 translate-y-0 blur-0' : 'opacity-0 translate-y-8 blur-[2px]'} ${idx % 2 === 1 ? 'lg:mt-8' : 'lg:mt-0'}`}
              style={{ transitionDelay: `${120 + idx * 100}ms` }}
            >
              {/* Hero Image */}
              <div className="mb-4 transition-transform duration-300 group-hover:-translate-y-2 group-hover:scale-105">
                <img 
                  src={hero.image} 
                  alt={hero.name}
                  className="w-full h-auto object-contain"
                />
              </div>
              
              {/* Hero Name */}
              <h3 className="font-poppins font-medium text-base text-[#151716] text-center">
                {hero.name}
              </h3>
            </div>
          ))}
        </div>

        {/* Decorative Lines - Centered Below Section */}
        <div className="flex items-center justify-center gap-3">
          <div className="w-12 h-1 bg-brown"></div>
          <div className="w-12 h-1 bg-brown"></div>
          <div className="w-12 h-1 bg-brown"></div>
        </div>
      </div>
    </section>
  );
};

export default ComicHeroes;
